import React from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';

export default (t, onPermissionTypeChange, allAvailableContent = [], allContent = {}) => {
  const availableContentRefs = new Set(
    allAvailableContent.map(c => c.contentRef || c.content).filter(Boolean),
  );

  const isCTA = record => record.type === 'cta' || (!record.type && record.callToAction);
  const isForm = record => record.type === 'rule' || (!record.type && record.form);

  return [
    {
      title: t('pathways:ProcedurePathways.wizard.careTeamRules.columns.formName'),
      dataIndex: 'form',
      key: 'itemName',
      ellipsis: true,
      render: (form, record) => {
        if (isCTA(record)) {
          return record.callToAction?.name;
        }

        if (isForm(record) && record.contentRef && !availableContentRefs.has(record.contentRef)) {
          return (
            <p className="rule-status-text">
              {t('pathways:ProcedurePathways.wizard.careTeamRules.formRemoved')}
            </p>
          );
        }

        return form?.name || form?.title || form?.latestVersion?.name;
      },
    },
    {
      title: t('common:buttons.delete'),
      dataIndex: 'onDelete',
      key: 'delete',
      width: 150,
      render: onDelete => (
        <Button onClick={onDelete}>
          <FontAwesomeIcon icon={faTrashAlt} /> {t('common:buttons.delete')}
        </Button>
      ),
    },
  ];
};
